export const NHOST_REFRESH_TOKEN = 'nhostRefreshToken'
